export default __webpack_public_path__ + "static/media/fitnessTracker2.5711a519.jpg";